export const Panel = ({ title, action, children, className = "", testId, padded = true }) => (
    <section className={`rounded-xl border border-white/5 bg-nx-alt ${className}`} data-testid={testId}>
        {title && (
            <header className="flex items-center justify-between border-b border-white/5 px-5 py-3.5">
                <h2 className="text-[11px] font-bold uppercase tracking-[0.18em] text-nx-mute">{title}</h2>
                {action}
            </header>
        )}
        <div className={padded ? "p-5" : ""}>{children}</div>
    </section>
);

export const Skeleton = ({ className = "" }) => (
    <div className={`animate-pulse rounded-lg bg-white/[0.04] ${className}`} aria-hidden="true" />
);

export const EmptyState = ({ title, desc, icon: Icon, testId }) => (
    <div className="flex flex-col items-center justify-center px-6 py-12 text-center" data-testid={testId}>
        {Icon && (
            <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-white/5 bg-nx-soft text-nx-mute">
                <Icon size={17} strokeWidth={1.5} aria-hidden="true" />
            </span>
        )}
        <p className="mt-4 text-[11px] font-bold uppercase tracking-[0.18em] text-nx-mute">{title}</p>
        {desc && <p className="mt-1.5 max-w-xs text-xs leading-relaxed text-nx-mute/80">{desc}</p>}
    </div>
);

export const ErrorState = ({ testId }) => (
    <div className="flex items-center justify-center px-6 py-10 text-center" data-testid={testId}>
        <p className="text-xs font-semibold text-nx-mute">Unable to load data right now. Please try again shortly.</p>
    </div>
);
